import moment from "moment";
import { bookDemo } from "@/api/userApi.js";
import { isRealVisitor } from "@/assets/js/utility.js";
export default {
  data() {
    return {
      formData: {
        companyName: null,
        fullName: null,
        email: null,
        interests: [],
        notes: null
      },
      loading: false,
      selectedZoneObj: {},
      interestsName: [],
      is: false,
      rules: {
        companyName: [
          { required: true, message: 'Company name is required', trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: 'Contact full name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Invalid email address', trigger: ['blur', 'change'] }
        ],
        interests: [
          { required: true, message: 'Interest is required', type: 'array', trigger: 'change' }
        ]
      }
    }
  },
  created() {
  },
  mounted() {
    this.formData.companyName = this.passForm.companyName;
    this.formData.fullName = this.passForm.fullName;
    this.formData.email = this.passForm.email;
    this.formData.notes = this.passForm.notes;
    this.formData.selectedDate = this.passForm.selectedDate;
    this.formData.selectedTime = this.passForm.selectedTime;
    this.formData.selectedCity = this.passForm.selectedCity;
    this.formData.normalizedOffset = this.passForm.normalizedOffset;
    if (this.passForm.interests.length > 0) {
      this.formData.interests = this.passForm.interests;
    }
    this.selectedZoneObj = (this.timezones || []).find((tz) => tz.value == this.passForm.selectedZone);

    this.$nextTick(() => {
      this.$refs.fullNameInput?.focus()
    });
    window.scrollTo({ top: 0,  behavior: "smooth" });
  },
  props: {
    preview: {
      type: Boolean,
      default: false
    },    
    passForm: {
      type: Object,
      default: () => {}
    },    
    timezones: {
      type: Array,
      default: () => []
    },
    showKeyboard: {
      type: Boolean,
      default: false
    },   
  },
  methods: {
    formatDate(date, fmt = 'YYYY-MM-DD') {
      if (!date) {
        return this.$moment().format(fmt);
      } else {
        return this.$moment(date).format(fmt);
      }
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
    async handleSubmit() {
      try {
        const valid = await this.validate();
        if (!valid) {
          return;
        }             
        const params = {
          starttime: moment.tz(this.formData.selectedTime, this.selectedZoneObj.tzCode).utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
          company: this.formData.companyName,
          name: this.formData.fullName,
          timezone: this.selectedZoneObj.tzCode,
          email: this.formData.email,
          interests: this.formData.interests.join(","),
          notes: this.formData.notes,
          resource: this.getResource()
        }
        this.loading = true;
        const res = await bookDemo(params);
        if (res.data.success) {
          if (isRealVisitor()) {
            if (window.dataLayer) {
              window.dataLayer.push({ event: 'demo_booking_submitted', resource: params.resource || 'direct' });
            }

            if (typeof window.gtag === 'function') {
              window.gtag('event', 'generate_lead', { resource: params.resource || 'direct', form: 'book_demo_modal' });
            }
          }
          const rawpath = this.$route.path;
          const base = rawpath === '/' ? '' : rawpath.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
          history.pushState({ popup: 'submit' }, '', `${base}/bookdemo/submitdemo`);
          this.interestsName = this.formData.interests.map(item => {
            if (item == 1) return this.$t("booking.interests_1");
            else if (item == 2) return this.$t("booking.interests_2");
            else if (item == 3) return this.$t("booking.interests_3");
            else return ""
          });
          return new Promise(resolve => {
            setTimeout(() => {
              this.$emit('handleConfirm');
              this.loading = false;
              resolve({ success: true });
            }, 5000); // wait 5 seconds, prevent calendly haven finish update the latest booking date
          });
        } else {
          this.loading = false;
          this.$message.error(res.data.data || this.$t('err_msg_booking_failed'));
          return { success: false, message: res.data.data || "" };
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(this.$t('err_msg_booking_failed'));
        return { success: false, message: error.message || "" };
      }
    },
    handleChange(key) {
      this.$emit('handleUpdate', key, this.formData[key]);      
    },
    handleBookAnother() {      
      this.$emit('handleUpdate', 'openTimeSlot', false);
      this.$emit('handleBookAgain');
    },
    getFormatedString(data) {
      if (data && data != 'undefined' && data != undefined && data != 'null') {
        return data.replace(/\n/g, '<br>');
      }
      return '-';
    },
    getResource() {
      if (this.$route.fullPath.includes('/FB/')) {
        return 'Facebook';
      } else {
        return null;
      }
    }
  },
}